import { useClientCategories } from "api/Client/category";
import NavigationCard from "components/ClientLayoutPages/NavigationCard/NavigationCard";
import NavigationCardContainer from "components/ClientLayoutPages/NavigationCard/NavigationCardContainer";
import SkeletonList from "components/SkeletonList/SkeletonList";
import useParam from "Hooks/useParam";
import React from "react";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";

export default function Categories() {
  const categoryId = useParam("categoryId");
  const {
    data: categories,
    isLoading: categoriesIsLoading,
    isSuccess: categoriesIsSuccess,
    isError: categoriesIsError,
  } = useClientCategories(categoryId);

  if (categoriesIsError) return <h1>خطأ</h1>;

  return (
    <div className="portal-page-card rounded-[1.75rem] p-4 md:p-6 h-full">
      <div
        className="flex flex-wrap gap-1 text-md md:text-xl"
        // style={{ color: "var(--layout-text)" }}
      >
        <Link to={""} className="duration-200 hover:opacity-80">
          المنتجات
        </Link>
        {categoriesIsSuccess ? (
          <NestedNavigation data={categories.data.navigate} />
        ) : null}
      </div>

      {categories?.data?.currentCategory?.description ? (
        <div
          className="portal-message my-4 rounded-2xl p-4"
          // style={{ color: "var(--layout-text)" }}
        >
          {categories.data.currentCategory.description}
        </div>
      ) : null}

      <div className="mt-4 w-full max-w-5xl mx-auto">
        {categoriesIsLoading ? <SkeletonList number={8} /> : null}
        {categoriesIsSuccess ? (
          <NavigationCardContainer>
            {categories.data.categories.map((category) => (
              <NavigationCard
                key={category.id}
                {...{ ...category, link: `?categoryId=${category.id}` }}
              />
            ))}
            {categories.data.products.map((product) => (
              <NavigationCard
                key={product.id}
                {...{
                  ...product,
                  link: `/control-panel/product?productId=${product.id}`,
                }}
              />
            ))}
          </NavigationCardContainer>
        ) : null}
      </div>
    </div>
  );
}

const NestedNavigation = ({ data }) => {
  if (!data) return null;

  return (
    <>
      <Link
        to={`?categoryId=${data.id}`}
        className="flex items-center gap-1 text-md duration-200 hover:opacity-80"
      >
        <IoIosArrowBack className="portal-accent" />
        {data.name}
      </Link>
      {data.navigate ? <NestedNavigation data={data.navigate} /> : null}
    </>
  );
};
